/**
 * qsrTasks — lightweight persisted task store for the QSR demo (localStorage).
 * Assigned Corvana AI actions become tracked tasks with an owner + due time that
 * survive reloads and carry over across days (overdue items stay until actioned).
 */
const KEY = (bid) => `qsr_tasks_${bid || 'demo'}`;

export function loadTasks(bid) {
  try { return JSON.parse(localStorage.getItem(KEY(bid))) || null; } catch { return null; }
}
export function saveTasks(bid, list) {
  try { localStorage.setItem(KEY(bid), JSON.stringify(list)); } catch { /* ignore */ }
}

export function computeDue(urgency) {
  const d = new Date();
  if (urgency === 'high') { d.setHours(d.getHours() + 4); }
  else if (urgency === 'medium') { d.setDate(d.getDate() + 1); d.setHours(11, 0, 0, 0); }
  else { d.setDate(d.getDate() + 3); d.setHours(11, 0, 0, 0); }
  return d.toISOString();
}

export function isOverdue(t) {
  return t.status !== 'done' && new Date(t.due).getTime() < Date.now();
}

export function relativeDue(iso) {
  const d = new Date(iso).getTime();
  const now = Date.now();
  const dayMs = 86400000;
  const diff = d - now;
  const days = Math.round(diff / dayMs);
  if (diff < 0) {
    const od = Math.max(1, Math.round(-diff / dayMs));
    return { label: od === 1 ? 'Overdue · 1 day' : `Overdue · ${od} days`, overdue: true };
  }
  const time = new Date(iso).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  if (days <= 0) return { label: `Due today · ${time}`, overdue: false };
  if (days === 1) return { label: `Tomorrow · ${time}`, overdue: false };
  return { label: `In ${days} days`, overdue: false };
}

// Seeded backlog so the demo shows carried-over, un-actioned items from prior days.
export function seedBacklog() {
  const y = new Date(); y.setDate(y.getDate() - 1); y.setHours(17, 0, 0, 0);
  const y2 = new Date(); y2.setDate(y2.getDate() - 2); y2.setHours(11, 0, 0, 0);
  return [
    { id: 'qt_seed1', actionId: 'seed1', title: 'Cover Southport dinner runner gap', owner: 'Rhys T.', store: 'Southport', priority: 'high', due: y.toISOString(), status: 'open', createdAt: y.toISOString() },
    { id: 'qt_seed2', actionId: 'seed2', title: 'Reset Penrith combo upsell script', owner: 'Aisha K.', store: 'Penrith', priority: 'medium', due: y2.toISOString(), status: 'open', createdAt: y2.toISOString() },
  ];
}
